export enum ConfigManagerPropertiesEnum {
  loggedInUserRoot = 'loggedInUserRoot',
  dmsCorpCode = 'dmsCorpCode',
}
